import React from "react";

import LoginForm from "../LoginBlock";

import classes from "./AuthBlock.module.scss";

interface AuthProps {
    isRegister: boolean
    onRegister: (isRegister: boolean) => void
}

const AuthBlock: React.FC<AuthProps> = () => {

    return (
        <div className={classes.authBlockWrap}>
            <div className={classes.authBlockFormWrap}>
                <LoginForm/>
            </div>
        </div>
    );
};
export default AuthBlock;
